<div class="container-fluid px-0">
  <div class="row  mx-0 my-0 h-100">
    <div class="col-12 px-0 d-flex justify-content-center">
      <div class="rectangle">
        <div class="col-12 px-0 d-flex">
          <label class="title">Üye Ol</label>
        </div>
        <div class="col-12 px-0 d-flex phone-number-div">
          <label class="phone-number">(532) 232 12 13</label>
          <img class="edit-icon" [src]="'assets/images/edit.png'" [srcset]="'assets/images/edit@2x.png 2x, assets/images/edit@3x.png 3x'" alt="logo">
        </div>
        <div class="col-12 px-0 d-flex">
          <label class="description">Telefon numaranıza gelen <span
            class="text-style">6 haneli kodu girin</span></label>
        </div>
        <div class="col-12 otp-div">
          <ng-otp-input (onInputChange)="onOtpChange($event)" [config]="config"></ng-otp-input>
        </div>
        <div class="col-12 px-0 d-flex">
          <div class="countdown-web">
            <nz-countdown [nzPrefix]="'Kodunuz'" [nzSuffix]="'içinde numaranıza gönderilecektir'" [nzValue]="deadline"
                          [nzFormat]="'mm:ss'"
                          [nzValueStyle]="{'margin-top': '56px', 'font': '400 14px/20px Roboto, Helvetica Neue, sans-serif', 'font-weight': '300', 'font-size': '18px','line-height': '1.22'}"></nz-countdown>
          </div>
          <div class="countdown-mobile">
            <nz-countdown [nzPrefix]="'Kodunuz'" [nzSuffix]="'içinde numaranıza gönderilecektir'" [nzValue]="deadline"
                          [nzFormat]="'mm:ss'"
                          [nzValueStyle]="{'margin-top': '50px', 'font': '400 14px/20px Roboto, Helvetica Neue, sans-serif', 'font-weight': '300', 'font-size': '12px','line-height': '1.83', 'text-align': 'center'}"></nz-countdown>
          </div>
        </div>
        <div class="col-12 d-flex button-div">
          <button class="button-style"><span class="text-style">Devam Et</span></button>
        </div>
      </div>
    </div>
  </div>
</div>
